import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, catchError, of } from 'rxjs';
import { APP_CONFIG } from '../../global/config/config.token';
import { AppConfig } from '../../global/config/app.config';
import { ExpenseLookup } from '../models/ExpenseLookupModel';
import { ExpenseRequestModel } from '../models/ExpenseRequestModel';
import { LookupItem, SearchModel } from '../../global/model/SearchModel';
import { ExpenseLineItemModel } from '../models/ExpenseLineItemModel';
import { ExpenseAttachmentModel } from '../models/ExpenseAttachmentModel';
import { ExpenseApprovalViewModel } from '../models/ExpenseApprovalViewModel';
import { ExpenseRequestComplianceViewModel } from '../models/ExpenseRequestComplianceViewModel';
import { ExpenseUploadResponse } from '../models/ExpenseUploadResponse';
import { ExpenseItemizationSheetRow } from '../models/ExpenseItemizationSheetRow';

@Injectable({
  providedIn: 'root',
})
export class AddExpenseService {
  constructor(private http: HttpClient,
    @Inject(APP_CONFIG) private config: AppConfig) {
  }
  getExpenseSearchColumnsAndFilters = (campaignId: number): Observable<SearchModel> => {
    const url = `${this.config.apiUrl}expense/expense-columns?campaignId=${campaignId}`;
    return this.http.get<SearchModel>(url, { withCredentials: true });
  }
  searchExpenses(campaignId: number, searchfilters: string, search: string | null) {
   const body = {
      campaignId,
      search,
      searchfilters
    };

    return this.http.post<any>(`${this.config.apiUrl}expense/expense-search`, body, { withCredentials: true });
  }
  getapprovals(params: { requestId: number; }) {
    var url = `${this.config.apiUrl}expense/expense-approvals`
    return this.http.get<any>(url, { params, withCredentials: true });
  }
  downloadAttachement(filePath: string) {
    return this.http.get(`${this.config.apiUrl}expense/lineattachements-download?filePath=${filePath}`, { responseType: 'blob', withCredentials: true });
  }
  getLookups(campaignId: number): Observable<ExpenseLookup> {
    return this.http.get<ExpenseLookup>(`${this.config.apiUrl}expense/expense-lookups?campaignId=${campaignId}`, { withCredentials: true });
  }
  getExpenseDetails(requestId: number): Observable<ExpenseRequestModel> {
    return this.http.get<ExpenseRequestModel>(`${this.config.apiUrl}expense/expense-details?requestId=${requestId}`, { withCredentials: true });
  }
  saveExpense(request: ExpenseRequestModel): Observable<number> {
    return this.http.post<number>(`${this.config.apiUrl}expense/add-edit-expense-detail`, request, { withCredentials: true });
  }
  getFundCodesByCampaign(campaignId: number): Observable<LookupItem[]> {
    return this.http.get<LookupItem[]>(`${this.config.apiUrl}expense/childfundcodes?childCampaignId=${campaignId}`, { withCredentials: true });
  }
  getCheckbooksByFundCode(campaignId: number, fundCodeId: number): Observable<LookupItem[]> {
    return this.http.get<LookupItem[]>(`${this.config.apiUrl}expense/checkbooks?campaignId=${campaignId}&fundCodeId=${fundCodeId}`, { withCredentials: true });
  }
  getExpenselineitems(requestId: number, isItemizations: boolean) {
    return this.http.get<ExpenseLineItemModel[]>(`${this.config.apiUrl}expense/lineitems?requestId=${requestId}&isItemizations=${isItemizations}`, { withCredentials: true });
  }
  saveExpenselineitem(request: ExpenseLineItemModel): Observable<boolean> {
    return this.http.post<boolean>(`${this.config.apiUrl}expense/lineitems-add`, request, { withCredentials: true });
  }
  updateExpenselineitem(request: ExpenseLineItemModel): Observable<boolean> {
    return this.http.post<boolean>(`${this.config.apiUrl}expense/lineitems-update`, request, { withCredentials: true });
  }
  deleteExpenselineitem(lineItemId: number): Observable<boolean> {
    return this.http.post<boolean>(`${this.config.apiUrl}expense/lineitems-delete?lineItemId=${lineItemId}`, '', { withCredentials: true });
  }
  getExpenselineattachments(requestId: number) {
    return this.http.get<ExpenseAttachmentModel[]>(`${this.config.apiUrl}expense/lineattachements?requestId=${requestId}`, { withCredentials: true });
  }
  saveExpenselineattachment(request: FormData): Observable<boolean> {
    return this.http.post<boolean>(`${this.config.apiUrl}expense/lineattachements-add`, request, { withCredentials: true });
  }
  deleteExpenselineattachment(attachmentId: number): Observable<boolean> {
    return this.http.post<boolean>(`${this.config.apiUrl}expense/lineattachements-delete?attachmentId=${attachmentId}`, '', { withCredentials: true });
  }
  addApprover(requestId: number, approverId: string): Observable<boolean> {
    return this.http.post<boolean>(`${this.config.apiUrl}expense/addapprovers?requestId=${requestId}&approverId=${approverId}`, '', { withCredentials: true });
  }
  getApprovers(requestId: number) {
    return this.http.get<ExpenseApprovalViewModel[]>(`${this.config.apiUrl}expense/getapprovers?requestId=${requestId}`, { withCredentials: true });
  }
  deleteApprover(expenseApprovalId: number): Observable<boolean> {
    return this.http.post<boolean>(`${this.config.apiUrl}expense/deleteapprover?expenseApprovalId=${expenseApprovalId}`, '', { withCredentials: true });
  }
  updateapprovalFlag(requestId: number, required: boolean): Observable<boolean> {
    return this.http.post<boolean>(`${this.config.apiUrl}expense/updateapprovalflag?requestId=${requestId}&required=${required}`, '', { withCredentials: true });
  }
  getExpensecompliance(requestId: number, campaignId: number, childCampaignId: number) {
    return this.http.get<ExpenseRequestComplianceViewModel>(`${this.config.apiUrl}expense/compliance?requestId=${requestId}&campaignId=${campaignId}&childcampaignId=0`, { withCredentials: true });
  }
  saveExpenseCompliance(request: ExpenseRequestComplianceViewModel): Observable<boolean> {
    return this.http.post<boolean>(`${this.config.apiUrl}expense/updatecompliance`, request, { withCredentials: true });
  }
  getExpenseItemizationTemplate() {
    return this.http.get(`${this.config.apiUrl}expense/itemization-template`, { responseType: 'blob', withCredentials: true });
  }
  uploadItemization(request: FormData): Observable<ExpenseUploadResponse> {
    return this.http.post<ExpenseUploadResponse>(`${this.config.apiUrl}expense/itemization-fileupload`, request, { withCredentials: true });
  }
  saveItemization(requestId: number, request: ExpenseItemizationSheetRow[]): Observable<boolean> {
    return this.http.post<boolean>(`${this.config.apiUrl}expense/itemization-save?requestId=${requestId}`, request, { withCredentials: true });
  }
  getErrorFile(filename: string) {
    return this.http.get(`${this.config.apiUrl}expense/itemization-errorfile?filename=${filename}`, { responseType: 'blob', withCredentials: true });
  }
  getWarningFile(filename: string) {
    return this.http.get(`${this.config.apiUrl}expense/itemization-warningfile?filename=${filename}`, { responseType: 'blob', withCredentials: true });
  }
  deleteAllExpenselineitem(requestId: number): Observable<boolean> {
    return this.http.post<boolean>(`${this.config.apiUrl}expense/lineitems-deleteall?requestId=${requestId}`, '', { withCredentials: true });
  }
  deleteExpenseRequest(expenseRequestId: number): Observable<boolean> {
    return this.http.post<boolean>(`${this.config.apiUrl}expense/expenserequest-delete?expenseRequestId=${expenseRequestId}`, '', { withCredentials: true });
  }
  deleteMultipleExpenseRequest(expenseRequestIds: number[]): Observable<boolean> {
    return this.http.post<boolean>(`${this.config.apiUrl}expense/expenserequest-delete-multi`, expenseRequestIds, { withCredentials: true });
  }
  expenseRequestApprove(expenseRequestId: number): Observable<boolean> {
    return this.http.post<boolean>(`${this.config.apiUrl}expense/expenserequest-approve?expenseRequestId=${expenseRequestId}`, '', { withCredentials: true });
  }
  expenseRequestApprovemulti(expenseRequestIds: number[]): Observable<boolean> {
    return this.http.post<boolean>(`${this.config.apiUrl}expense/expenserequest-approve-multi`, expenseRequestIds, { withCredentials: true });
  }
  expenseRequestSendForPayment(expenseRequestId: number): Observable<boolean> {
    return this.http.post<boolean>(`${this.config.apiUrl}expense/expenserequest-sendpayment?expenseRequestId=${expenseRequestId}`, '', { withCredentials: true });
  }
  expenseRequestUnApprove(expenseRequestId: number): Observable<boolean> {
    return this.http.post<boolean>(`${this.config.apiUrl}expense/expenserequest-unapprove?expenseRequestId=${expenseRequestId}`, '', { withCredentials: true });
  }
  expenseRequestSendForPaymentMulti(expenseRequestIds: number[]): Observable<boolean> {
    return this.http.post<boolean>(`${this.config.apiUrl}expense/expenserequest-sendpayment-multi`, expenseRequestIds, { withCredentials: true });
  }
}
